import React from 'react';

export const UserIcon = () => {
  return (
    <span
      title={'Contacts'}
      className="solstice-icon- solstice-icon-contact"
      style={{ color: '#757575', fontSize: '14px' }}
    />
  );
};
